import { render, staticRenderFns } from "./LampInfo.vue?vue&type=template&id=7edb0d85"
import script from "./LampInfo.vue?vue&type=script&lang=js"
export * from "./LampInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports